var isSearching = false; // A flag to prevent multiple submits
var readyToSubmit = false; // The onsubmit handler must not handle its own submission 
var mouse_is_inside_megamenu = false;

$(document).ready(function () {
    //$('select #bootstrap-select').selectpicker();
    var pinchables = [];
    Cookies.set('Culture', culture);

    if (document.URL.indexOf('review') === -1 && document.cookie.indexOf('accepts_cookies') === -1) {
        $('.cookiebar-wrapper').show();
        $('.cookiebar-close').click(function () {
            var d = new Date();
            d.setTime(d.getTime() + (732 * 24 * 60 * 60 * 1000));
            document.cookie = "accepts_cookies=1;expires=" + d.toUTCString(); + ";path=/" + culture + ";";

            $('.cookiebar-wrapper').hide();
        });
    }

    if (document.URL.indexOf('review') === -1 && document.cookie.indexOf('accepts_cookies') === -1) {
        $('#cookiePopupModal').modal({
            backdrop: 'static',
            keyboard: false
        })

        $('#cookiePopupModal a').click(function (e) {
            var url = $(this).attr('href') + '?frame=popup';
            $.get(url, function (result) {
                $(".modal-body #moreInfo").html(result);
                $(".modal-body #moreInfo").css({ 'height': '400px', 'border': '1px solid #eee' });
            });
            return false;
        });

        $('#cookiePopupModal').modal('show');
        $('.cookiepopup-agreed').click(function () {
            var d = new Date();
            d.setTime(d.getTime() + (732 * 24 * 60 * 60 * 1000));
            document.cookie = "accepts_cookies=1;expires=" + d.toUTCString(); + ";path=/" + culture + ";";

            $('#cookiePopupModal').modal('hide');
        });
    }

    $("a.megamenu-trigger").each(function () {
        jsHref = $(this).attr("data-jshref");

        if (jsHref != "") {
            $(this).attr("href", jsHref);
        }
    });


    $('tr[id^="cartItem-"] .remove > a').click(function (e) {
        e.preventDefault();

        var el = $(e.target).closest('tr')[0];
        AnalyticsBuilder.create(window.inTestMode ? { debug: true } : {}).addProduct({
            'name': $(el).find('.product-name-only a').text(),
            'quantity': parseInt($(el).find('.cartItem-quantity').text())
        }).asRemoveFromCart().send(function () {
            window.location = $(el).find('.remove > a')[0].href;
        });
    });

    $('.megamenu').hover(function () {
        mouse_is_inside_megamenu = true;
    }, function () {
        mouse_is_inside_megamenu = false;
    });


    $('#cart-and-userdata .country a').click(function (e) {
        $('.megamenu.fullscreen').toggleClass('opened');

        if ($('.menu-mobile').hasClass('menu-mobile-visible')) {
            $('.menu-mobile').removeClass('menu-mobile-visible');
        } else {
            $('.overlay').toggleClass('overlay-active');
        }

        $('body').toggleClass('no-scroll');

        e.preventDefault();
        return true;
    });


    $('.overlay').on('click', function () {
        if ($($('.megamenu.fullscreen').hasClass('opened'))) {
            $('.megamenu.fullscreen').removeClass('opened');
            $('.overlay').removeClass('overlay-active');
            $('body').removeClass('no-scroll');
        }
    });

    $("body").mouseup(function (e) {
        if (!mouse_is_inside_megamenu && !$(e.target).hasClass('megamenu-trigger')) {
            if ($('.megamenu-active').length > 0) {
                var code = $('.megamenu-active').attr('id').replace('megamenu', '');
                ToggleMegaMenu(code);
            }
            //$(".megamenu-active").slideUp();
            //$(".megamenu-active").removeClass("megamenu-active");
        }
    });

    // Setup techgalls
    try {
        TechGallery.setup();
        var t = 0;
        //console.log(t);
    } catch (ex) {
        // do nothing
    }

    $(document).on('ready.px.parallax.data-api', function () {
        //console.log(navigator.userAgent);
        if (!(/MSIE (\d+\.\d+);/.test(navigator.userAgent)) && navigator.userAgent.indexOf('Trident/') < 0) {
            $('[data-parallax="scroll"]').parallax();
        } else {
            $('[data-parallax="scroll"]').each(function () {
                var self = $(this);
                var src = self.data('backgroundSrc');

                console.log(src);
                var img = $('<img src="' + src + '" />').css({
                    position: 'absolute',
                    height: '600px',
                    minWidth: '100%',
                    zIndex: -2
                });


                img.one('load', function () {
                    img.css({
                        left: (img.width() - self.width()) / -2 + 'px'
                    });

                    $(window).resize(function () {
                        img.css({
                            left: (img.width() - self.width()) / -2 + 'px'
                        });
                    });
                });

                self.css({ overflow: 'hidden' }).prepend(img);
            });
        }
    });

    // header/brandswitch ONLOAD
    HandleScrollHeaderAndBrandSwitch(this);

    // header+brandswitch ONSCROLL
    $(window).on("scroll", function () {
        HandleScrollHeaderAndBrandSwitch(this);
    });
    $(window).on('resize', function () {
        HandleScrollHeaderAndBrandSwitch(this);
    });

    $(".compare-bar-wrapper .compare-bike").each(function () {

        var iScrollPos = 0;
        $(window).scroll(function () {
            var iCurScrollPos = $(this).scrollTop();
            if (iCurScrollPos > iScrollPos) {
                $('.compare-bar-wrapper').addClass('collapsed');
            }
            iScrollPos = iCurScrollPos;
        });
    });

    // toggle menu
    $("a#toggle-menu").on('click', function () {
        if ($('.megamenu.fullscreen').hasClass('opened'))
            $('.megamenu.fullscreen').removeClass('opened');
        else
            $(".overlay").toggleClass("overlay-active");

        $("nav.menu-mobile").toggleClass("menu-mobile-visible");
    });

    $("a#toggle-menu").on({
        'touchstart': function (event) {
            event.preventDefault();

            if ($('.megamenu.fullscreen').hasClass('opened'))
                $('.megamenu.fullscreen').removeClass('opened');
            else
                $(".overlay").toggleClass("overlay-active");

            $("nav.menu-mobile").toggleClass("menu-mobile-visible");
        }
    });


    $("div.backtotop a").click(function (event) {

        event.preventDefault();

        // scroll
        newPosition = 0;
        $('html, body').animate({
            scrollTop: newPosition
        }, 1000);

    });

    /* MAGNIFIC popup */
    $('.image-popup-fit-height').magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        image: {
            verticalFit: true
        },
        zoom: {
            enabled: true, // By default it's false, so don't forget to enable it
            duration: 300, // duration of the effect, in milliseconds
            easing: 'ease-in-out', // CSS transition easing function 
        }
    });

    $('.whatsmysize-image').magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        image: {
            verticalFit: true
        }
    });


    $('.modal').on('shown.bs.modal', function (e) {
        var target = $(e.target);
        var body = target.children('.modal-dialog').children('.modal-content').children('.modal-body');

        if (target.data('iframe') !== '' && body.children().length === 0) {
            var isMobile = findBootstrapEnvironment() === 'xs';

            var height = $(window).height() - (isMobile ? 142 : 120);
            body.css({
                overflowY: isMobile ? 'scroll' : 'hidden',
                overflowX: 'hidden',
                height: isMobile ? height : 'blaat',
                width: body.width()
            });

            var element = $('<iframe style="width: 100%; height: ' + height + 'px; border:none;" src="' + target.data('iframe') + '"></iframe>');

            $(window).on('resize', function () {
                height = $(window).height() - (isMobile ? 142 : 120);
                $(element).css({ height: height });
            });

            body.html(element);
        }
    });

    /* MAGNIFIC popup url */
    $('.giantbicycles-magnific-popup-iframe').magnificPopup({
        type: 'iframe',
        iframe: {
            markup: '<div class="mfp-iframe-scaler">' +
                '<div class="mfp-close"></div>' +
                '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

            patterns: {
                giantbicycles: {
                    index: 'www.giant-bicycles.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

                    id: 'id=', // String that splits URL in a two parts, second part should be %id%
                    // Or null - full URL will be returned
                    // Or a function that should return %id%, for example:
                    // id: function(url) { return 'parsed id'; }

                    src: 'http://www.giant-bicycles.com/en-us/technology/item/%id%/?nav=false' // URL that will be set as a source for iframe.
                }
            }
        }
    });


    /* MAGNIFIC popup url */
    $('.magnific-popup-iframe').magnificPopup({
        type: 'iframe',
        iframe: {
            markup: '<div class="mfp-iframe-scaler">' +
                '<div class="mfp-close"></div>' +
                '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
            patterns: {
                giantbicycles: {
                    index: '/', // String that detects type of video.
                    id: function (url) {
                        return url;
                    }, // String that splits URL in a two parts, second part should be %id%
                    // Or null - full URL will be returned
                    // Or a function that should return %id%, for example:
                    // id: function(url) { return 'parsed id'; }
                    src: '%id%' // URL that will be set as a source for iframe.
                }
            }
        }
    });

    /* MAGNIFIC popup url */
    $('.magnific-popup-iframe-video').magnificPopup({
        type: 'iframe',
        iframe: {
            markup: '<div class="mfp-iframe-scaler">' +
                '<div class="mfp-close"></div>' +
                '<iframe class="mfp-iframe mfp-iframe-video" frameborder="0" scrolling="no"  style="background:#000;height:565px;overflow:hidden;" allowfullscreen></iframe>' +
                '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
            patterns: {
                giantbicycles: {
                    index: '/', // String that detects type of video.
                    id: function (url) {
                        return url;
                    }, // String that splits URL in a two parts, second part should be %id%
                    // Or null - full URL will be returned
                    // Or a function that should return %id%, for example:
                    // id: function(url) { return 'parsed id'; }
                    src: '%id%' // URL that will be set as a source for iframe.
                }
            }
        }
    });

    $(".fancybox").not('.fancybox-imageswiper').each(function (key, value) {
        $(value).fancybox({
            maxWidth: 1000,
            maxHeight: 1000,
            fitToView: true,
            width: '90%',
            height: '90%',
            autoSize: true,
            padding: 0,
            helpers: {
                overlay: {
                    locked: false
                }
            }
        });
    });

    $(".fancyboxSmall").each(function (key, value) {
        $(value).fancybox({
            maxWidth: 450,
            maxHeight: 420,
            fitToView: true,
            autoSize: true,
            padding: 0,
            helpers: {
                overlay: {
                    locked: false
                }
            }
        });
    });


    $(".fancybox-imageswiper").each(function (key, value) {
        $(value).fancybox({
            maxWidth: 1000,
            maxHeight: 1000,
            fitToView: true,
            scrolling: false,
            minWidth: 1000,
            autoSize: true,
            padding: 0,
            helpers: {
                overlay: {
                    locked: false
                }
            },
            afterShow: function () {
                if ($('.swiper-slide').length > 1)
                    new Swiper('.swiper-container', {
                        width: '1000',
                        height: '1000',
                        pagination: '.swiper-pagination',
                        paginationClickable: true,
                        initialSlide: $(value).data('slide'),
                        prevButton: '.swiper-button-prev',
                        nextButton: '.swiper-button-next',
                        visibilityFullFit: true
                    });
            },
            afterClose: function () {
                $('.swiper-slide').each(function (key, value) {
                    $(value).parent().css({ transform: 'none' });
                });
            }
        });
    });

    /************************************************
     *                                              *
     *              Bike comparison                 *
     *                                              *
     ************************************************/

    var compareTemplate =
        '<div class="compare-bike">' +
        '<span class="glyphicon glyphicon-remove remove" id="{id}"></span>' +
        '<div class="img-wrap">' +
        '<img alt="{name}" src="{image}" />' +
        '</div>' +
        '<p class="name">{name}</p>' +
        '</div>';

    // Set's up the compare bar
    (function (storage, storageKey, template, culture) {
        "use strict"

        if (culture === 'global')
            return;

        // Doesn't support web storage API
        if (storage == undefined)
            return (console.warn.bind(console) || console.log.bind(console))
                ("Storage access denied: disabling compare functionaltity.");

        storageKey = storageKey + "_" + culture;

        var storeData = [];
        var store = window["compareStore"] = window["compareStore"] || {
            add: function (data) {
                if (!data)
                    return;

                if (storeData.length === 3) {
                    if ($('.compare-bar-wrapper').hasClass('collapsed'))
                        $('.compare-bar-wrapper').removeClass('collapsed');
                    return;
                }

                if (!this.__contains(data.id)) {
                    storeData.push(data);
                    storage.setItem(storageKey, JSON.stringify(storeData));
                }

                this.__render();

                if ($('.compare-bar-wrapper').hasClass('collapsed')
                    && !$('.compare-bar-wrapper').hasClass('no-use')
                    && !$('.compare-bar').hasClass('add-animation')) {
                    $('.compare-bar').addClass('add-animation');
                    setTimeout(function () {
                        $('.compare-bar').removeClass('add-animation');
                    }, 1000);
                }
            },
            remove: function (id) {
                for (var i in storeData)
                    if (storeData[i]["id"] === id) {
                        storeData.splice(i, 1);
                        storage.setItem(storageKey, JSON.stringify(storeData));

                        this.__render();
                    }
            },
            get: function () {
                var ids = [];
                for (var i in storeData)
                    ids.push((storeData[i]["globalcatalogue"] === "True" ? "gc" : "lc") + "@" + storeData[i]["id"]);
                return ids;
            },
            __contains: function (id) {
                for (var i in storeData)
                    if (storeData[i]["id"] === id)
                        return true;
                return false;
            },
            __render: function (init) {
                for (var i = 0; i <= 3; i++) {
                    var data = storeData[i];
                    if (data !== undefined)
                        $('#compare-' + (i + 1))
                            .html(template
                                .replace(/{id}/, data["id"])
                                .replace(/{name}/, data["name"])
                                .replace(/{name}/, data["name"])
                                .replace(/{image}/, data["image"]));
                    else
                        $('#compare-' + (i + 1)).html('');
                }

                $('.compare-bar .remove').click(function (e) {
                    store.remove(Number(e.target.id));
                });

                $('#compare-count').html(storeData.length);
                if (storeData.length > 0)
                    setTimeout(function () {
                        $('.compare-bar-wrapper').removeClass('no-use' + (!init && storeData.length === 1 ? ' collapsed' : ''));
                    }, 100);
                else if (!$('.compare-bar-wrapper').hasClass('no-use'))
                    $('.compare-bar-wrapper').addClass('no-use').addClass('collapsed');

                if (storeData.length > 1)
                    $('.compare-bar .btn-compare').removeAttr('disabled');
                else if ($('.compare-bar .btn-compare').has('[disabled]'))
                    $('.compare-bar .btn-compare').attr('disabled', true);

                if (storeData.length === 3 && $('.compare-bar-wrapper').hasClass('collapsed') && !init)
                    $('.compare-bar-wrapper').removeClass('collapsed');
            }
        };

        for (var i = 0; i < storage.length; i++) {
            var key = storage.key(i);
            if (key === storageKey) {
                storeData = JSON.parse(storage.getItem(key));
                store.__render(true);

                return;
            }
        }

        storage.setItem(storageKey, '[]');
    })((function (storageName) {
        try { return window[storageName] } catch (e) { }
    })("sessionStorage"), "Giant_ProductCompare", compareTemplate, culture);

    //$('body').on('click', '.btn-compare:not(#compare-bikes)', function (e) {
    $('.btn-compare:not(#compare-bikes)').click(function (e) {
        e.preventDefault();

        var data = $(e.target).hasClass('glyphicon')
            ? $('.btn-compare').closest().data()
            : $(e.target).data();

        window.compareStore.add(data);

        return false;
    });

    $('#compare-bikes').click(function (e) {
        window.location = '/' + culture + '/comparison/'
            + window.compareStore.get().join('-');
    });

    $('.compare-bar .header').click(function () {
        $('.compare-bar-wrapper').toggleClass('collapsed');
    });

    var lastPos = 0;
    var onTimeout = false;
    $(window).scroll(function (e) {
        if (onTimeout) return;

        var pos = $(this).scrollTop();

        if (pos > lastPos && !$('.compare-bar-wrapper').hasClass('collapsed'))
            $('.compare-bar-wrapper').addClass('collapsed');

        lastPos = pos;

        // To prevent excessive performance loss
        onTimeout = true;
        setTimeout(function () {
            onTimeout = false;
        }, 50);
    });

    $("a.galleryzoom").fancybox({
        'zoomOpacity': true,
        'overlayShow': false,
        'zoomSpeedIn': 500,
        'zoomSpeedOut': 500,
        helpers: {
            overlay: {
                locked: false
            }
        }
    });




    /* ACT LIKE TAB CLICK */
    $("a.act-like-tab-click").click(function (event) {

        // get target
        myHref = $(this).attr("href");

        // prevent anchor link
        event.preventDefault();

        // set link state
        $("div.scrollmenu a").removeClass("active");
        // activate
        var linkId = myHref.replace("#", "");
        $("div.scrollmenu a#scrollmenu-" + linkId).addClass("active");

        //scroll
        ScrollToTarget(myHref);
    });


    /* CALLOUTS */
    $("a.callout-link").click(function () {

        // set all links to default
        $("a.callout-link").removeClass("callout-link-active");

        // get id of infoblock
        myId = this.id;
        divId = myId.replace("link", "info");

        // get rel
        myRel = $(this).attr("rel");

        // check if click to show or click to hide
        if ($("div#" + divId).is(":visible")) {
            $(this).removeClass("callout-link-active");
            // close this one
            $("div#" + divId).fadeOut('fast');
            $(this).text(myRel);
        } else {
            $(this).addClass("callout-link-active");
            // hide all info
            $("div.callout-info").fadeOut();
            // show this one
            $("div#" + divId).slideDown();
            // set position of infoblock
            yPos = $(this).offset().top + 22;
            $("div#" + divId).offset({ top: yPos, left: 0 });
            // change link text
            $(this).text("X");
        }

    });


    // SK: reposition callouts based on css image size
    $(".callout-link").each(function () {

        originalWidth = 970;
        imageWidth = $("#highlights .image img").width();

        factor = (imageWidth / 970);

        originalTop = $(this).attr("data-originaltop");
        originalLeft = $(this).attr("data-originalleft");

        newTopValue = originalTop * factor;
        newLeftValue = originalLeft * factor;

        $(this).css('top', newTopValue);
        $(this).css('left', newLeftValue);

    });

    /* TECH LEGACY */

    $("area.explanation-link").click(function (event) {

        var linkId = this.id;
        var divId = linkId.replace("explanation-link", "explanation-info");

        var offset = $(this).offset();
        mouseTopPosition = event.pageY - offset.top - 30;

        // check if click to show or click to hide
        if ($("div#" + divId).is(":visible")) {
            // close this one
            $("div#" + divId).fadeOut('fast');
        } else {
            // hide all info
            $("div.explanation-info").fadeOut();
            // show this one
            $("div#" + divId).slideDown();
            // change position
            $("div#" + divId).css("top", mouseTopPosition + "px");
        }
    });

    $("a.close-all-explanations").click(function () {
        $("div.explanation-info").fadeOut();
    });

    var matchList = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('SmartSearchDto'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        limit: 100,
        remote: {
            //url: 'http://localhost:59019/api/smartsearch/search?searchTerm=%QUERY',
            url: '/' + culture + '/search/jsonsearch?keyword=%QUERY',
            wildcard: '%QUERY'
        }
    });
    matchList.initialize();

    $("input#search").typeahead({
        hint: false,
        minLength: 3,
    },
        {
            templates: {
                suggestion: function (data) {
                    var item = data.Title;
                    var html = $('<div></div>');
                    var query = data._query;
                    try {
                        var i = item.toString().toLowerCase().indexOf(query.toLowerCase());
                    } catch (e) {

                    }
                    var len, leftPart, middlePart, rightPart, strong;
                    len = query.length;
                    while (i > -1) {
                        leftPart = item.substr(0, i);
                        middlePart = item.substr(i, len);
                        rightPart = item.substr(i + len);
                        strong = $('<strong></strong>').text(middlePart);
                        html
                            .append(document.createTextNode(leftPart))
                            .append(strong);
                        item = rightPart;
                        i = item.toString().toLowerCase().indexOf(query.toLowerCase());
                    }
                    var result = '<p>' + html.append(document.createTextNode(item)).html()
                    if (data.SubTitle.length > 0) { result += ' - ' + data.SubTitle }
                    result += "</p>";
                    return result;
                }
            },
            source: matchList.ttAdapter(),
            displayKey: 'Title',
            limit: 100000
        });

    $("input#search").bind('typeahead:selected', function (obj, item) {
        window.location = item.Url;
    });

    $("body .header-search input").click(function () {
        $("body .header-search").addClass("header-search-active");
    });
    $("body a.hide-expanded-search").click(function () {
        $("body .header-search").removeClass("header-search-active");
    });


    $("header .header-search a.search-submit").click(function () {
        var inputValue = $("input#search").val();
        if (inputValue != "") {
            $("header .header-search form").submit();
        }
        else {
            $("body .header-search").addClass("header-search-active");
        }

    });



    $('.campaignPopover').popover();

    $('body').on('mouseover', '.campaignPopover', function (e) {
        $(this).popover('show');
    });


    $("a.toggle-div").each(function () {

        $(this).click(function () {
            myId = this.id;
            divId = myId.replace("toggle-", "");
            $("#" + divId).slideToggle();
            $(this).toggleClass("toggle-clicked");
        });

    });



    $("div.toggle-filter").click(function () {

        $(this).next("ul").slideToggle('fast');
        $(this).toggleClass("toggle-filter-expanded");

        $(this).find("i.up").toggle();
        $(this).find("i.down").toggle();

    });


    $('.cataloguefilter').click(function () {
        var filter = $(this).data().level;
        var li = $(this).parent();
        var filterGroup = $(this).parent().parent();

        if (!li.hasClass('disabled')) {
            if (li.hasClass('active')) {
                //deactivate this filter
                setActive = false;
                li.removeClass('active');
            } else {
                li.addClass('active');
            }

            var filterGroups = $('body .chapter ul').toArray();

            //show / hide items
            var activeFilters = $('body .chapter ul li.active a');
            var filterOrAppend = 'append'; //Determine if items will be append or be filtered. If item is visible it will be a filter. If item isn't filter products will be append.
            //if ($('.bikeseries-summary.' + filter + ':visible').length > 0 || $('.gearproduct-summary.' + filter + ':visible').length > 0) {
            //    filterOrAppend = 'filter';
            //}
            if (filterGroup.find('li.active a').length < 2) {
                filterOrAppend = 'filter';
            }
            $.each($('.bikeseries-summary, .gearproduct-summary'), function () {
                var item = $(this);
                var showItem = false;
                var showItemHasBeenChanged = false;

                if (activeFilters.length == 0) {
                    showItem = true;
                } else {
                    $.each(filterGroups, function () {
                        if (showItemHasBeenChanged == true) {
                            return false;
                        }

                        var activeFiltersThisGroup = activeFilters;
                        if (filterOrAppend == 'append') {
                            activeFiltersThisGroup = filterGroup.find('li.active a');
                        }

                        $.each(activeFiltersThisGroup, function () {
                            var activeFilter = $(this);
                            if (filterOrAppend == 'filter') {
                                showItem = true;
                            }
                            if (filterOrAppend == 'append') {
                                //Append: product must contain at least 1 filter
                                if (item.hasClass(activeFilter.data().level)) {
                                    showItem = true;
                                    showItemHasBeenChanged = true;
                                    return false;
                                }
                            } else { //filter: product must contain all filters
                                if (showItem == true && item.hasClass(activeFilter.data().level)) {
                                    showItem = true;
                                } else {
                                    showItem = false;
                                    showItemHasBeenChanged = true;
                                    return false;
                                }
                            }
                        });
                    });
                }

                // SK: hide all
                item.hide();

                if (showItem == true) {
                    item.fadeIn("fast");
                } else {
                    //item.hide();
                }
            });

            //show/hide filters
            $.each(filterGroups, function () {
                if ($(this).attr('id') != filterGroup.attr('id') || activeFilters.length == 0) {
                    $(this).find('li.disabled').removeClass('disabled');
                    var activeFiltersThisGroup = $(this).find('li').toArray();
                    $.each(activeFiltersThisGroup, function () {
                        var showItem = true;
                        //if (!$(this).hasClass('all')) {
                        var activeFilter = $(this).find('a');
                        var filter = activeFilter.data().level;
                        //check item is visible at ui
                        if ($('.bikeseries-summary.' + filter + ':visible').length > 0 || $('.gearproduct-summary.' + filter + ':visible').length > 0) {
                            //showItem = true;
                        } else {
                            //showItem = false;
                            $(this).addClass('disabled')
                            $(this).removeClass('active')
                        }
                    });
                }
            });
        }
    });


    $('.btn-enable-progress').click(function () {
        $(this).addClass('btn-run-progress');
    });




    $('.cataloguesort').click(function () {
        var $wrapper = $('.productsContainer');
        var sortby = $(this).attr('data-level');
        $("p.sortby a.cataloguesort").removeClass("selected");
        $(this).addClass("selected");

        $wrapper.find('.bikeseries-summary, .gearproduct-summary').sort(function (a, b) {
            if (sortby == 'sort-pricedown') {
                return parseFloat($(a).attr('data-pricemin')) > parseFloat($(b).attr('data-pricemin')) ? 1 : -1;
            } else {
                return parseFloat($(a).attr('data-pricemax')) < parseFloat($(b).attr('data-pricemax')) ? 1 : -1;
            }
        })
            .appendTo($wrapper);
    });

    //toggle description
    $("a#toggle-description-secondbit").each(function () {
        $(this).click(function () {

            isVisible = $("#description-secondbit").is(":visible");

            $("#description-secondbit").slideToggle("slow");
            linkTextDefault = $(this).attr("data-linktextdefault");
            linkTextClicked = $(this).attr("data-linktextclicked");

            if (isVisible == true) {
                $(this).text(linkTextDefault);
            } else {
                $(this).text(linkTextClicked);
            }
        });
    });


    $("select#variation-switcher").change(function () {

        objOption = $("select#variation-switcher option:selected");
        // get jump url
        gearProductUrl = objOption.attr("data-gearproducturl");
        // go
        window.location.href = gearProductUrl;

    });


    $("a.toggle-video").click(function () {
        $(this).parent().parent().parent().addClass("content-wrapper-video-playing");
        $(this).hide();
        myId = this.id;

        // hide link
        iframeId = myId.replace("toggle-", "");

        // show iframe
        $("iframe#" + iframeId).show();

        // autoplay
        iframeSrc = $("iframe#" + iframeId).attr("src");
        $("iframe#" + iframeId).attr("src", iframeSrc + "&autoplay=1");

    });

    $("a.setMainImage").click(function () {
        // get new main image src
        var myRel = $(this).attr("rel");
        var pinchable = $(this).data('pinchable');

        // get loopindex attr
        var loopIndex = $(this).data("loopindex");
        $('img[name="mainImage"]').parent().data('slide', loopIndex);
        objImage = $('img[name="mainImage"]')
            .attr('src', myRel).data('pinchable', pinchable);

        // change swiper link to correct slide
        if (isMobile())
            $("a#imageSwiperLink").each(function () {
                currentHref = "" + this.href;
                newHref = currentHref.substring(0, currentHref.lastIndexOf("slide="));
                newHref = newHref + "slide=" + loopIndex;
                $(this).attr("href", newHref);
            });

        resetPinchables();
    });


    $("a#imageSwiperLink").each(function () {

        var isPopupSwitchVisible = $("#switch-to-hide-image-popup").is(':visible');
        if (isPopupSwitchVisible == true) {

            $(this).removeClass("fancybox");
            $(this).removeClass("fancybox.iframe");
            var imageSrc = document.getElementsByName("mainImage").src;
            $(this).attr("href", imageSrc);

        }

    });


    /* NEW ZOOM open */
    $(".open-zoomed-image-modal").click(function () {

        // show window
        $(".zoomed-image-modal").addClass("zoomed-image-modal-active");

        $(".zoomed-image").draggable();

    });


    /*  NEW ZOOM close */
    $(".close-zoomed-image-modal").click(function () {

        // show window
        $(".zoomed-image-modal").removeClass("zoomed-image-modal-active");

        // clean src of main
        // $("img.zoomed-image-closeup").css("top", "-20%");
        //$("img.zoomed-image-closeup").css("left", "0");
        //$("img.zoomed-image-closeup").removeClass("zoomed-image-closeup");
        //$("img.zoomed-image-closeup").draggable('option', 'disabled', true);
    });





    /* ECOMMERCE SIZE AND COLOR EVENTS */
    $("form#clickandcollect select#colorSelector").each(function () {
        HandleProductColorAndSizeData(this);
    });
    $("form#clickandcollect select#colorSelector").change(function () {
        HandleProductColorAndSizeData(this);
    });
    $("form#clickandcollect div#oneColor").each(function () {
        HandleProductColorAndSizeData(this);
    });

    $('.getContactForm').click(function () {
        $('#contactModal').modal('show');
    });


    $('.getstockalert').click(function () {
        $('#stockAlertModal #partnumberCode').val($(this).attr('data-partnumbercode'));
        $('#stockAlertModal').modal('show');
    });

    $('#sendStockAlert').click(function () {
        $('#stockAlertModal .alert').remove();
        $.ajax({
            type: 'POST',
            url: '/' + culture + '/shop/stockalert',
            data: { partnumberCode: $('#partnumberCode').val(), email: $('#Email').val(), zipcode: $('#Zipcode').val() },
            success: function (data) {
                if (data == "True") {
                    $('#stockAlertModal').modal('hide');
                } else {
                    $('#stockAlertModal .modal-body').prepend('<div class="alert alert-danger">' + data + '</div>');
                }
            }
        });
    });

    //Shop - start
    $('body').on('click', '.addCartItem', function (e) {

        if (hasValidSizeColorUsage() == true) {
            var productId = $(this).attr('data-productId');
            if (productId.length == 0) {
                productId = window.productId;
            }
            var partnumbercode = $(this).attr('data-partnumbercode');
            var productType = $(this).attr('data-productTypeId');
            var quantity = parseInt($(this).attr('data-quantity'));
            var dealercode = $(this).attr('data-dealerCode');
            var continueShoppingUrl = $(this).attr('data-continueShoppingUrl');
            var globalCatalogue = $(this).attr('data-globalcatalogue');
            var label;
            if ($(e.target).is('.btn'))
                label = $(e.target).is('.btn-pickituphere') ? 'Pick it up here' : undefined;
            else
                label = $(e.target).closest('.btn').is('.btn-pickituphere') ? 'Pick it up here' : undefined;

            if (productType == undefined) {
                productType = productTypeId;
            }
            AddCartItem(productId, partnumbercode, productType, quantity, dealercode, continueShoppingUrl, label, globalCatalogue);
        }
    });

    $('form#clickandcollect').submit(function () {
        hasValidSizeColorUsage();
    });


    //$('body').on('click', 'input[name="ShippingOption"]', function () {
    //    var shippingOption = $(this).val();
    //    SetShippingOption(shippingOption);
    //});

    //$('body').on('click', 'input[name="paymentoption"]', function () {
    //    //SetPaymentOption($(this).val());
    //    //show extra payment fields
    //    //$('.paymentExtraData').hide();
    //    //if ($(this).parents('.paymentOption').find('.paymentExtraData')) {
    //    //    $(this).parents('.paymentOption').find('.paymentExtraData').show();
    //    //}
    //    //change confirm label
    //    if ($(this).val() == 'affirm') {
    //        $('.btnConfirm').html('Complete your application with Affirm <i class="glyphicon glyphicon-menu-right"></i>');
    //    } else {
    //        $('.btnConfirm').html('Confirm <i class="glyphicon glyphicon-menu-right"></i>');
    //    }
    //});

    //TODO: Implement Enhanced E-Commerce Tracking for Coupon Codes
    //$('#validateCoupon').click(function () {
    //    $('.couponResult').remove();
    //    var self = $(this);
    //    $.ajax({
    //        type: 'POST',
    //        url: '/' + culture + '/shop/validatecoupon',
    //        data: { coupon: $('#Coupon').val() },
    //        success: function (data) {
    //            if (data.Valid == true) {
    //                self.after('<div class="couponResult"><i class="glyphicon glyphicon-ok"></i> ' + data.Message + '</div>');
    //            } else {
    //                self.after('<div class="couponResult couponResult-NotValid"><i class="glyphicon glyphicon-remove"></i> No valid coupon</div>');
    //            }
    //            UpdateCart();
    //        }
    //    });
    //});

    $('#lnkShowDifferentDeliveryAdress').click(function () {
        if ($('#deliveryAddressContainer').is(":visible")) {
            //set fields not required
            $('#deliveryAddressContainer').find('input,select').removeClass('required');
        } else {
            //set fields required
            $('#deliveryAddressContainer').find('input,select').addClass('required');
            $('input[name="Order.OrderDeliveryAddress2"]').removeClass('required');
            $('input[name="Order.OrderDeliveryAddress3"]').removeClass('required');
        }
        $('#deliveryAddressContainer').toggle();
    });

    $('#lnkCreateAccount').click(function () {
        $('#passwordContainer').toggle();
    });

    //$('form[name="formOrder"]').submit(function (e) {
    //    $('#btnConfirm').attr('disabled', 'disabled');

    //    if ($('input[name="paymentoption"]:checked').val() == 'stripe' || ($('input[name="paymentoption"]') != undefined) && $('input[name="paymentoption"]').val() == 'Stripe') {
    //        e.preventDefault();
    //        if ($('input[name="stripeToken"]').val() != undefined && $('input[name="stripeToken"]').val().length > 0) {
    //            return true;
    //            //$('#formOrder').submit();
    //        }
    //        var $form = $('form[name="formOrder"]');
    //        Stripe.card.createToken($form, function (status, response) {
    //            var $form = $('form[name="formOrder"]');

    //            if (response.error) {
    //                // Show the errors on the form
    //                alert(response.error.message);
    //                $form.find('#btnConfirm').prop('disabled', false);
    //            } else {
    //                // token contains id, last4, and card type
    //                var token = response.id;
    //                // Insert the token into the form so it gets submitted to the server
    //                $form.append($('<input type="hidden" name="stripeToken" />').val(token));
    //                // and submit
    //                $form.get(0).submit();
    //            }
    //        });
    //        return false;
    //    } else {
    //        return true;
    //    }
    //});



    $("#checkout-and-cart button#btnConfirm").click(function () {

        //var hasProgressClass = $(this).hasClass("btn-run-progress");

        //console.log("hello world");

    });


    $('#sizeSelector').change(function () {
        var value = $(this).val();
        $('.action').hide();
        $('#action-' + value).show();
    });




    $("#inputFindLocalStock").keydown(function (event) {
        if (event.keyCode == 13) {
            $("#btnFindLocalStock").trigger("click");
            return false;
        }
    });

    var pinchable;
    $('#imageSwiperLink > .main-image').click(function (e) {
        $(e.target).parent().find('.back-layer')
            .addClass('active')
            .css({
                zIndex: 4999
            });
        $(e.target).parent().find('.close-bar-top').show();
        $(e.target).parent().find('.main-image').css({
            opacity: 0
        });

        pinchable = $('<div class="pinchable-container active"><img class="img-responsive pinchable" src="' + $(e.target).data('pinchable') + '" /></div>');
        pinchable.children().on('load', function () {
            new Pinchable(pinchable.children()[0]);
        });

        $(e.target).parent().append(pinchable);
    });

    $('#imageSwiperLink > .back-layer').click(close);
    $('.back-layer .close-btn').click(close);

    function close(e) {
        var back = $('.back-layer');

        back.find('.close-bar-top').hide();
        back.removeClass('active');
        setTimeout(function () {
            back.css({ zIndex: -100 });
            pinchable.remove();
            back.parent().find('.main-image').css({
                opacity: 1
            });
        }, 200);

        pinchable.css({
            transform: 'translateY(0)'
        });
    }

    $("#loginModal input").keydown(function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            $("#btnLogin").trigger("click");
            return false;
        }
    });

    $('body').on('click', '.btn-findLocalstock,#findLocalStock', function () {
        $('#ModalLocalStockFinder').modal('show');
    });


    if (isMobile()) {
        $('.panel-default').on('shown.bs.collapse', function (e) {
            var $panel = $(e.target).parent('.panel');
            var extraOffset = 68;

            setTimeout(function () {
                $('html,body').animate({
                    scrollTop: $panel.offset().top - extraOffset
                }, 750);
            }, 400);
        });
    }

    $('.panel-collapse').on('show.bs.collapse', function () {
        $('.panel-collapse').collapse('hide');
    })

    $('input[name="agreeToTermsAndConditions"]').change(function (e) {
        var filtered = $('input[name="agreeToTermsAndConditions"]').not(this);
        var val = this.checked;
        filtered.prop('checked', val);
    });



    $('body').on('click', 'a.cart-summary-container', function (e) {
        e.preventDefault();
        if ($('#summary-total').html().length > 0) {
            ShowCartSummary();
        }
    });


    //Shop - end
    var today = new Date();
    var maxYear = today.getFullYear() - 10;
    var birthDayMaxDate = new Date(maxYear, 1, 1);
    var minYear = today.getFullYear() - 119;
    var minDate = new Date(minYear, 1, 1);

    $('.birthday').datetimepicker({
        viewMode: 'years',
        format: 'L',
        maxDate: birthDayMaxDate,
        locale: cultureFull
    });

    $('.birthdayShop').datetimepicker({
        viewMode: 'years',
        format: 'L',
        locale: cultureFull,
        minDate: minDate,
        maxDate: today
    }).on('dp.change', function (e) {
        var element = angular.element($(this));
        var controller = element.controller();
        var scope = element.scope();
        scope.Cart.Order.BirthDateISO = e.date.format('YYYY-MM-DD');
        scope.$apply();
        $('#BirthDateISO').val(e.date.format('YYYY-MM-DD'));
    });

    $('.birthdayAccount').datetimepicker({
        viewMode: 'years',
        format: 'L',
        locale: cultureFull,
        minDate: minDate,
        maxDate: today
    }).on('dp.change', function (e) {
        var element = angular.element($(this));
        var controller = element.controller();
        var scope = element.scope();
        scope.Account.BirthDateISO = e.date.format('YYYY-MM-DD');
        scope.$apply();
        $('#BirthDateISO').val(e.date.format('YYYY-MM-DD'));
    });

    $('.birthdayRegistration').datetimepicker({
        viewMode: 'years',
        format: 'L',
        locale: cultureFull,
        minDate: minDate,
        maxDate: today
    }).on('dp.change', function (e) {
        var element = angular.element($(this));
        var controller = element.controller();
        var scope = element.scope();
        scope.Registration.Registration.BirthDateISO = e.date.format('YYYY-MM-DD');
        scope.$apply();
        $('#BirthDateISO').val(e.date.format('YYYY-MM-DD'));
    });

    $('.datetimeRegistration').datetimepicker({
        maxDate: new Date(),
        format: 'L',
        locale: cultureFull,
        minDate: minDate,
        maxDate: today
    }).on('dp.change', function (e) {
        var element = angular.element($(this));
        var controller = element.controller();
        var scope = element.scope();
        scope.Registration.Registration.BuyDateISO = e.date.format('YYYY-MM-DD');
        scope.$apply();
        $('#BuyDateISO').val(e.date.format('YYYY-MM-DD'));
    });

    $('.datetime').datetimepicker({
        maxDate: new Date(),
        format: 'L',
        locale: cultureFull
    });


    /* on mobile devices no parallaxing please */
    HandleParallaxBanners(this);


    $("#btnSearchEvents").on('click', function (e) {
        if (!readyToSubmit) {
            // Don't submit the form - we must first perform client-side geocoding (client-side because of limits on the amount of requests to the Google Maps API per 24 hour period)
            e.preventDefault();
        }
        else {
            // Geocoding has been done - submit the form
            return true;
        }
        // Don't start another search while another is still going
        if (isSearching) { return; }

        isSearching = true;

        // Start query to google
        getAddressFromGoogle();
    });

    $('#getBrowserLocationEvents').click(function () {
        getBrowserLocation(function (position) {
            $('#LatLng').val(position.coords.latitude + ',' + position.coords.longitude);
            readyToSubmit = true;
            $('#btnSearchEvents').trigger('click');
            //$('form#Geocoder').submit();
        });
    });


    $('a#toggle-storefilters').click(function () {
        $("div.storefilters div").slideToggle();
    });

    $('[data-toggle="tooltip"]').tooltip();

    $('.devtools').each(function () {
        var e = $(this);
        setTimeout(
            function () {
                e.find('.maximized').slideUp(400, 'swing',
                    function () {
                        e.find('.maximized').hide();
                        e.find('.minimized').show();
                        $('.devtools').removeClass('active');
                    });
            }
            , 6000);
    });

    $('#minimized').click(function () {
        $(this).hide();
        $('.devtools').addClass('active');
        $('.devtools .maximized').slideDown();
    });

    $('#showDevToolsDefault').change(function () {
        if (document.getElementById('showDevToolsDefault').checked) {
            createCookie("showDevToolsDefault", true, 999);
        } else {
            createCookie("showDevToolsDefault", false, 999);
        }
    });

    // mobile pinchable
    $('.pinchable').each(function (i, val) {
        pinchables.push(new Pinchable(val));
    });

    function resetPinchables() {
        $.each(pinchables, function (i, val) {
            val.reset();
        });
    }

    new SwipeGallery('.swipe-base', '.gallery-item');

    // divide data in specifications table
    HandleSpecificationsTable();


    $(".paymentContainer input.payment-option-radio").change(function () {

        // get value
        clickedValue = $(this).val();

        // toggle classes
        $(".paymentOption").addClass("paymentOption-inactive");
        $(".paymentOption-" + clickedValue).removeClass("paymentOption-inactive");

    });


    $(".faq-box").click(function () {

        // remove active
        $(".faq-box").removeClass("active");
        $(".faq-answer").hide();

        $(this).addClass("active");
        myId = this.id;
        divId = myId.replace("faq-box", "faq-answer");

        $("#" + divId).slideDown();

        // scroll
        var newPosition = $(".answers").offset().top;
        $('html, body').animate({
            scrollTop: newPosition - 150
        }, 1000);

    });

    $('form#Geocoder').submit(function (e) {
        //console.log($(this).serialize());
        if ($('#latlng').val() != '') {
            return true;
        } else {
            e.preventDefault();
            return false;
        }
    });


    $("a.toggle-unit").click(function () {

        $("a.toggle-unit").toggleClass("toggle-unit-active");

        $("span.value-mm").toggle();
        $("span.value-inch").toggle();
        $("span.inch-label").toggle();
        $("span.mm-label").toggle();

    });


    // owl carousel NL giant stores
    $(".owl-carousel").owlCarousel({
        loop: true,
        dots: true,
        dotsEach: true,
        autoplay: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            }
        }
    });


    //show swipe hand symbol on mobile
    $(".icon-hand-swipe").each(function () {
        var myHandIcon = this;

        $(".icon-hand-swipe-container").scroll(function () {
            // get id
            var divId = this.id;
            // get scroll value
            var scrollValue = $(this).scrollLeft();
            if (scrollValue > 0) {
                // wait and fade out
                setTimeout(function () {
                    $("#" + divId + " .icon-hand-swipe").addClass("fadeout");
                }, 100);
            }
        });

    });


    $('a#link-serviceappointmentmodal').click(function () {
        var currentWindowHeight = $(window).height();
        $("iframe#planitiframe").css('height', currentWindowHeight * 0.75 | 0);
    });


    /* BOOTSTRAP MODAL PREV NEXT
 
     $("div[id^='techmodal']").each(function () {
 
         var currentModal = $(this);
 
         //click next
         currentModal.find('.btn-next').click(function () {
             currentModal.modal('hide');
             currentModal.closest("div[id^='techmodal']").nextAll("div[id^='techmodal']").first().modal('show');
         });
 
         //click prev
         currentModal.find('.btn-prev').click(function () {
             currentModal.modal('hide');
             currentModal.closest("div[id^='techmodal']").prevAll("div[id^='techmodal']").first().modal('show');
         });
 
     });
     */


    $("a#show-explanation-popup").click(function () {
        $("#explanation-popup").show();
        $(".content-wrapper-teaserwebsite").hide();
        $(".content-wrapper-subscribe-success").hide();
    });
    $("#explanation-popup").click(function () {
        $("#explanation-popup").hide();
        $(".content-wrapper-teaserwebsite").show();
        $(".content-wrapper-subscribe-success").show();
    });

    $('#contactForm').on('submit', function (e) {
        e.preventDefault();
        grecaptcha.ready(function () {
            grecaptcha.execute(window.GoogleRecaptchaSiteKey, { action: 'social' })
                .then(function (token) {
                    $('#recaptchaToken').val(token);
                    e.currentTarget.submit();
                });
        });
    });

    $('body').on('click', '#pb_btnClose', function (e) {
        $('#pbModal').modal('hide');
    });
}); 

function Pinchable(element) {
    var me = this;
    var portHeight = $(window).height() * (findBootstrapEnvironment() == 'xs' ? 0.55 : 0.45);


    $(element).css({
        position: 'absolute',
        maxHeight: 'initial',
        maxWidth: 'initial',
        margin: 'initial'
    });
    $(element).parent().css({
        height: portHeight,
        overflow: 'hidden'
    });

    var width = element.naturalWidth / 3;
    var height = element.naturalHeight / 3;
    var image = {
        width: element.naturalWidth / 3,
        height: element.naturalHeight / 3
    };
    var container = {
        width: $(element).parent().width(),
        height: $(element).parent().height()
    }

    //console.log({
    //    width: width,
    //    height: height
    //});

    var scale = {
        image: .33,
        last: .33
    };

    var bounds = {
        x: 0,
        y: 0
    };

    var pos = {
        x: 0,
        y: 0
    };
    var last_delta = {
        x: 0,
        y: 0
    };

    var manager = new Hammer(element);
    var pan = new Hammer.Pan({
        enable: true
    });
    var pinch = new Hammer.Pinch({
        enable: true
    });
    var press = new Hammer.Press({
        enable: true,
        time: 1250
    });

    press.recognizeWith(pan);
    pan.recognizeWith(pinch);

    manager.add([press, pinch, pan]);

    manager.on('pinch', function (e) {
        var deltaScale = (e.scale - scale.last);
        scale.image = scale.image + ((deltaScale > 0 ? deltaScale : (deltaScale * 1.75)) * 0.33);
        scale.last = e.scale;

        if (scale.image < 0.33)
            scale.image = 0.33;
        else
            if (scale.image > 1)
                scale.image = 1;

        _calculateBounds();

        _setMove();
    });
    manager.on('pinchend', function (e) {
        scale.last = 1.0;
    });

    manager.on('pan', function (e) {
        pos.x = pos.x - (last_delta.x - e.deltaX);
        pos.y = pos.y - (last_delta.y - e.deltaY);
        last_delta.x = e.deltaX;
        last_delta.y = e.deltaY;

        _checkBounds();

        _setMove();
    });
    manager.on('panend', function () {
        last_delta.x = last_delta.y = 0;
    });

    manager.on('press', function () {
        //window.location = $(element).attr('src');
        var url = $(element).attr('src');

        var link = document.createElement('a');
        link.href = url;
        link.download = url.substring(url.lastIndexOf('/') + 1,
            (url.lastIndexOf('?') > -1 ? url.lastIndexOf('?') : url.length));

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    });

    this.reset = function () {
        if (image.width > container.width) {
            var t = {
                width: container.width * 3,
                height: (image.height / (image.width / container.width)) * 3,
                left: -($(element).parent().width()),
                top: '50%',
                marginTop: ((image.height / (image.width / container.width)) * -1.5) + 'px'
            };

            //console.log(t);
            //console.log($(element).height());
            $(element).css(t);
        }

        if (image.width <= container.width) {
            var t = {
                width: (image.width / (image.height / portHeight)) * 3,
                height: portHeight * 3,
                left: -(image.width / (image.height / portHeight)) + (($(element).parent().width() - (image.width / (image.height / portHeight))) / 2),
                top: '50%',
                marginTop: -(portHeight) + 'px'
            };
            //console.log(t);
            $(element).css(t);
        }

        _calculateBounds();
        _setMove();
    }

    element.onload = function () {
        loaded = true;

        scale.image = .33;
        scale.last = 1.0;
        pos.x = 0;
        pos.y = 0;

        _calculateDimension();
        me.reset();
    };

    var loaded = false;
    setTimeout(function () {
        if (!loaded && !isNaN(element.naturalWidth)) {
            _calculateDimension();
            me.reset();
        }
    }, 50);

    window.addEventListener('resize', function () {
        container.width = $(element).parent().width();
        container.height = $(element).parent().height();
        portHeight = $(window).height() * 0.45;
        me.reset();
    });

    function _setMove() {
        $(element).css({
            transform: 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0px) scale(' + scale.image + ', ' + scale.image + ')'
        });
    }

    function _calculateBounds() {
        bounds.x = ((image.width * (scale.image / 0.33)) - image.width) / 2.75;
        bounds.y = ((image.height * (scale.image / 0.33)) - image.height) / 3.75;

        //console.log(scale);
        //console.log(image);
        //console.log(bounds);

        _checkBounds();
    }

    function _calculateDimension() {
        image.width = element.naturalWidth / 3;
        image.height = element.naturalHeight / 3;
        if (isNaN(image.width))
            image.width = $(element).parent().width();
    }

    function _checkBounds() {
        if (pos.x < 0 && pos.x + bounds.x < 0)
            pos.x = bounds.x * -1;
        if (pos.x > 0 && pos.x - bounds.x > 0)
            pos.x = bounds.x;
        if (pos.y < 0 && pos.y + bounds.y < 0)
            pos.y = bounds.y * -1;
        if (pos.y > 0 && pos.y - bounds.y > 0)
            pos.y = bounds.y;
    }
}

loadPinchable = function (fnCb, emulateTouch) {
    if (emulateTouch == undefined)
        emulateTouch = false;

    if (emulateTouch) {
        var script = document.createElement('script');
        script.src = '//cdn.rawgit.com/hammerjs/touchemulator/0.0.2/touch-emulator.js'
        script.onload = function () {
            TouchEmulator();
            loadScript();
        };

        document.body.appendChild(script);
    } else
        loadScript();

    function loadScript() {
        var script = document.createElement('script');
        script.src = '/Scripts/hammer.js';
        script.onload = fnCb;

        document.body.appendChild(script);
    }
};

function SwipeGallery(selectorBase, selectorGalleryItem) {
    var imageElement =
        '<div class="giant-swipe-tile" data-count="{count}">' +
        '<img src="{src}" alt="Gallery Image" />' +
        '<div class="caption">' +
        '<p>{caption}</p>' +
        '</div>' +
        '</div>';
    var swipePanelElement =
        '<div class="gallery-backdrop"><div class="swipe-panel"></div></div>';

    var panelStyle = {
        backdrop: {
            position: 'fixed',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            transition: 'background-color ease-out 200ms',
            zIndex: 9995
        },
        swipePanel: {
            position: 'fixed',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            zIndex: 10000
        }
    };

    var tileStyles = {
        wrapper: {
            position: 'fixed',
            width: 'calc(100% - 20px)',
            border: '1px solid rgba(255, 255, 255, 0.15)',
            borderRadius: 3,
            left: 10,
            zIndex: 9999
        },
        image: {
            width: '100%',
        },
        caption: {
            width: '100%',
            padding: 5,
            color: '#fff',
            backgroundColor: 'rgba(0,0,0,0.7)'
        }
    };

    var indexStyles = {
        wrapper: {
            position: 'fixed',
            bottom: '5px',
            opacity: 0.6,
            padding: 0,
            margin: 0
        },
        pointer: {
            display: 'inline-block',
            width: 10,
            height: 10,
            backgroundColor: '#fff',
            borderRadius: '50%',
            margin: 5
        }
    };

    try {
        if (($ || false) === false)
            return;
    } catch (ex) {
        return;
    }

    var baseElement = $(selectorBase),
        galleryOpen = false;

    if (baseElement.length === 0)
        return;

    var images = $(selectorBase + ' ' + selectorGalleryItem),
        backdrop = $(swipePanelElement),
        imageTiles = [],
        index = $('<ul></ul>'),
        pointers = [];
    var swipePanel = backdrop.children();
    var curPosition = 0;

    backdrop.hide().css(panelStyle.backdrop)
        .click(toggleGall);
    swipePanel.css(panelStyle.swipePanel);
    index.css(indexStyles.wrapper);

    baseElement.append(backdrop);

    var windowHeight = $(window).height();

    var count = images.length;
    images.each(function (i, e) {
        $(this).click(toggleGall);

        var el = $(
            imageElement
                .replace('{count}', i)
                .replace('{src}', $(this).data('url'))
                .replace('{caption}', $(this).data('caption'))
        );
        el.hide().css(tileStyles.wrapper).children('img')
            .css(tileStyles.image);
        el.children('.caption').css(tileStyles.caption);

        var pointer = $('<li></li>');
        index.append(pointer.css(indexStyles.pointer));
        backdrop.append(el);

        if (!--count) {
            imageTiles = backdrop.children().not('.swipe-panel,ul');
            pointers = index.children();
            backdrop.append(index);
        }
    });

    function doSwipe(e) {
        if (!galleryOpen)
            return;

        switch (e) {
            case 'right':
                if (curPosition === 0)
                    return;
                curPosition--;
                break;
            case 'left':
                if (curPosition === (images.length - 1))
                    return;
                curPosition++;
                break;
        }

        calcImageStepping(true);
    }

    swipedetect(swipePanel[0], doSwipe);

    $(document).keydown(function (e) {
        switch (e.which) {
            case 37:
                doSwipe('right');
                break;
            case 39:
                doSwipe('left');
                break;
            default:
                return;
        }
        e.preventDefault();
    });

    function toggleGall(e) {
        if (galleryOpen) {
            $('body').css({ overflow: 'auto' });
            backdrop.hide().css({ backgroundColor: 'transparent' });
            imageTiles.hide();
            enableScroll();
        } else {
            curPosition = parseInt($(e.target).parent().data('count'));
            $('body').css({ overflow: 'hidden' });
            backdrop.show().css({ backgroundColor: 'rgba(0,0,0,0.4)' });
            calcImageStepping();
            index.css({ left: 'calc(50% - ' + index.width() / 2 + 'px)' });
            disableScroll();
        }
        galleryOpen = !galleryOpen;
    }

    function calcImageStepping(transition) {
        imageTiles.show().each(function (i) {
            var el = $(this);

            if (!transition) {
                el.css({ transition: 'none' });
            }

            var curCount = parseInt(el.data('count'));
            if (curCount < curPosition)
                el.css({ transform: 'translateX(' + -($(window).width() - 10) + 'px)' });
            else if (curCount > curPosition)
                el.css({ transform: 'translateX(' + ($(window).width() - 10) + 'px)' });
            else if (curCount == curPosition)
                el.css({ transform: 'translateX(0px)' });

            if (!transition) {
                el[0].offsetHeight;
                el.css({ transition: 'transform ease-out 200ms' });
            }

            var height = el.children('img').height();
            var capHeight = el.children('.caption').height();

            el.css({
                top: (windowHeight - height - capHeight) / 2
            });
        });
        pointers.css({ backgroundColor: indexStyles.pointer.backgroundColor });
        $(pointers[curPosition]).css({ backgroundColor: '#007aff' });
    }
}

//jQuery.loadScript = function (url, callback) {
//    jQuery.ajax({
//        url: url,
//        dataType: 'script',
//        success: callback,
//        async: true
//    });
//}

function loadExternalScript(url, callback) {
    try {
        jQuery.ajax({
            url: url,
            dataType: 'script',
            async: true,
            success: callback
        });
    } catch (e) {
        var script = document.createElement('script');
        script.src = url;
        if (document.body != null) {
            document.body.appendChild(script);
        } else if (document.head != null) {
            document.head.appendChild(script);
        }
    }
    //if (jQuery != undefined) {
    //    jQuery.ajax({
    //        url: url,
    //        dataType: 'script',
    //        async: true,
    //        success: callback
    //    });
    //} else {
    //    var script = document.createElement('script');
    //    script.src = url;
    //    if (document.body != null) {
    //        document.body.appendChild(script);
    //    } else if (document.head != null) {
    //        document.head.appendChild(script);
    //    }
    //}
}